export function removeSpaces(obj) {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    acc[key] = value ? String(value).trim() : value

    return acc
  }, {})
}
